import React, {Component} from 'react'
import Blueitems from '../components/Blueitems'
import Breakpoints from '../utils/breakpoints'
import contentfulData from '../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import MapComponent from '../components/MapComponent';
import NewsLetter from '../components/NewsLetter';
import FullPageBlueItem from '../components/FullPageBlueItem';
import ArticleImageWithText from '../components/ArticleImageWithText';
import ArticleHighlight from '../components/ArticleHighlight';
import Colors from '../utils/colors';
import {prettifyUrl, getLang} from "../utils/util-functions";

export class ClinicsParentPage extends Component {

  render (){

    const brand = getLang();
    const items = contentfulData.servicesData[brand].services;
    const title = contentfulData.singleData[brand].singleData.frontpageItemHeader;
    const secondTitle = contentfulData.singleData[brand].singleData.frontpageSecondTitle;
    const paragraph = contentfulData.singleData[brand].singleData.frontpagelongtext;
    const mapTitle = contentfulData.singleData[brand].singleData.frontpageMapTitle;
    const mapItems = contentfulData.clinicsData[brand].clinicsData;
    const emailText = contentfulData.singleData[brand].singleData.frontpageEmailText;
    const guides = contentfulData.guideArticlesData[brand].guideArticlesData;
    const currenNewstTitle = contentfulData.singleData[brand].singleData.frontpageWidgetTitle;
    const clinicOpenText = contentfulData.singleData[brand].singleData.clinicOpenTitle;
    const clinicBookingText = contentfulData.singleData[brand].singleData.clinicBookingText;

    return (
        <div>
          <StyleRoot>
            <div style={styles}>
              <div className="row" style={styles.responsiveDivider}>
                <div className="col-xs-12" style={styles.mobileMarginBlueitems}>
                  {_.sortBy(mapItems, sorted => sorted.name).map((item, i) =>
                      <FullPageBlueItem key={i} name={item.name} extraText={clinicOpenText} buttonLink={item.bookingUrl}
                                        buttonText={clinicBookingText + " " + item.name} location={item.coordinates}
                                        phoneText={item.phoneText} phone={item.phone} clickExtraText={this.props.clickClinic} history={this.props.history}/>
                  )}
                </div>
                <div className="clearfix"></div>
                <div style={styles.responsiveDivider} ></div>
                <div>
                  <div className="col-xs-12 col-md-8">
                    <div className="col-xs-12"> <h1 style={{fontFamily: 'Merryweather', marginTop: 16}}>{title}</h1></div>
                    <Blueitems items={items} history={this.props.history}/>
                    <div className="clearfix"></div>
                    <div className="col-xs-12">
                      <div style={styles.responsiveDivider} ></div>
                      <h1 style={[styles.responsiveDivider, {fontFamily: 'Merryweather'}]}>{secondTitle}</h1>
                      <p>{paragraph}</p>
                    </div>
                    <div className="clearfix" style={styles.responsiveDivider}></div>
                    {  _.sortBy(guides.filter(g => g.articleHighlight), [guide => guide.articleImage])
                        .map((guide, a) => {
                              if (guide.articleImage)
                                return <div style={styles.singleArticleLink} onClick={() => this.props.clickArticle(prettifyUrl(guide.articleHeadline))} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleImageWithText key={a} twoPanels={true} title={currenNewstTitle} headline={guide.articleHeadline} image={guide.articleImage.fields.file.url} /></div></div>
                              if (guide.articleHighlight)
                                return <div style={styles.singleArticleLink} onClick={() => this.props.clickArticle(prettifyUrl(guide.articleHeadline))} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}><ArticleHighlight key={a} headline={guide.articleHeadline} /></div></div>
                              return <div style={styles.singleArticleLink} onClick={() => this.props.clickArticle(prettifyUrl(guide.articleHeadline))} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}>{guide.articleHeadline}</div></div>
                            }
                    )}
                  </div>
                  <div className="col-md-4 col-xs-12 hidden-xs" >
                    <div style={styles.responsiveDivider} ></div>
                    <div className="clearfix"></div>
                    <div style={styles.responsiveDivider} ></div>
                    <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/>
                  </div>
                </div>
              </div>
              <div className="row" style={styles.newsLetterDivider}>
                <div className="col-xs-12">
                  <div className="col-xs-12"><NewsLetter text={emailText}/></div>
                </div>
              </div>
              <div style={styles.responsiveDivider}></div>
            </div>
          </StyleRoot>
        </div>
    )
  }

};

export default Radium(ClinicsParentPage);

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  firstRow: {
    marginTop: Breakpoints.componentDivider
  },
  divider: {
    marginTop: 20
  },
  singleArticleLink: {
    textDecoration: 'none',
    color: Colors.darkBlue,
    ':hover': {
      cursor: 'pointer'
    }
  },
  dividerSingleItem: {
    marginTop: 10,
    paddingTop: 10,
    paddingBottom: 10,
    [Breakpoints.media.siteUnderMaxWidth]: {
      marginTop: 0,
      paddingTop: 0,
      paddingBottom: 20,
    },
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  mobileMarginBlueitems: {
    [Breakpoints.media.siteUnderPadWidth]: {
      paddingLeft: 30,
      paddingRight: 30
    }
  },
  newsLetterDivider: {
    marginTop: 20,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: 0
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/ClinicsParentPage.js